function _navigator() {
    return navigator;
}
var NavigatorRef = /** @class */ (function () {
    function NavigatorRef() {
    }
    Object.defineProperty(NavigatorRef.prototype, "nativeNavigator", {
        get: function () {
            return _navigator();
        },
        enumerable: true,
        configurable: true
    });
    return NavigatorRef;
}());
export { NavigatorRef };
